/* eslint-disable react/no-unknown-property */
import type { FC, ReactElement } from 'react';

import Head from 'next/head';

import { AAFFonts } from '~/components/shared/core/typography/AAFFonts';
import { GSTARFonts } from '~/components/shared/core/typography/GSTARFonts';
import { WAHTSFonts } from '~/components/shared/core/typography/WAHTSFonts';
import { IS_DEV_WIREMOCK } from '~/utilities/constants';
import { AssetsMediaMap } from '~/utilities/constants/siteType.config';
import { useAppContext } from '~/utilities/context/static/AppContext';
import { SiteType } from '~/utilities/graphql/codegen';

const prefix = IS_DEV_WIREMOCK ? process.env.RUNTIME_ORIGIN : '';
const iconFontUrl = `${prefix}/_static/${process.env.BUILD_TIME}/fonts/gstar-icons.woff2`;

const fontface = `
@font-face {
  font-family: 'gstar-icons';
  src: url(${iconFontUrl}) format('woff2');
  font-style: normal;
  font-display: swap;
}
`;

export type FontsComponentProps = { fontAssetPath: string };

const siteMap: Record<SiteType, FC<FontsComponentProps>> = {
  [SiteType.Aaf]: AAFFonts,
  [SiteType.Employeeshop]: GSTARFonts,
  [SiteType.Gstar]: GSTARFonts,
  [SiteType.Outlet]: GSTARFonts,
  [SiteType.Wahts]: WAHTSFonts,
};

export const PreloadFonts = (): ReactElement => {
  const { siteType } = useAppContext();

  const fontAssetPath = `${AssetsMediaMap[siteType]}/fonts`;

  const FontsComponent = siteMap[siteType];

  return (
    <>
      <Head>
        <link
          rel="preload"
          href={iconFontUrl}
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
          fetchPriority="high"
        />
        {/* eslint-disable-next-line react/no-danger */}
        <style type="text/css" dangerouslySetInnerHTML={{ __html: fontface }} />
      </Head>
      <FontsComponent fontAssetPath={fontAssetPath} />
    </>
  );
};
